import { Component, OnDestroy, OnInit, ViewChildren } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Subject, Subscription, take, takeUntil, timer } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { GUEST_CART_ID, SIGNUP_MOBILE, SIGNUP_EMAIL, NUM_REGEX, PHONE_REGEX, EMAIL_REGEX } from '../../constants/constant';
import { StateService } from '../../service/state.service';
import { StorageService } from '../../service/storage.service';
import { UserService } from '../../service/user.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-signinmodal',
  imports: [FormsModule, CommonModule, ReactiveFormsModule],
  templateUrl: './signinmodal.component.html',
  styleUrls: ['./signinmodal.component.less'],
})
export class SigninmodalComponent implements OnInit, OnDestroy {
  counterStatus = false;
  countDown$: Subscription;
  counter = 30;
  tick = 1000;
  guestCartId: string | null;
  unsubscribe$ = new Subject();
  isApiHit: boolean = false;
  isSubmit: boolean = false;

  form: FormGroup;
  formInput = ['input1', 'input2', 'input3', 'input4', 'input5', 'input6'];
  @ViewChildren('formRow') rows: any;

  toFormGroup(elements: any) {
    const group: any = {};

    elements.forEach((key: any) => {
      group[key] = new FormControl('', Validators.required);
    });
    return new FormGroup(group);
  }

  keyUpEvent(event: any, index: number) {
    const target = event.target as HTMLInputElement;
    let re = /\b\d\b/;
    let pos;
    pos = index + 1;

    if (!re.test(target.value)) {
      target.value = target.value.slice(0, -1);
      pos--;
    }

    if (event.key == 'Backspace') {
      pos = index - 1;
    }

    if (pos > -1 && pos < this.formInput.length) {
      this.rows._results[pos].nativeElement.focus();
    }
  }

  ngOnInit() {
    this.stateService.guestUserFetch$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((res) => {
        if (res) {
          this.guestCartId = this.localService.getItem(GUEST_CART_ID);
        }
      });
  }

  transform(value: number): string {
    const minutes: number = Math.floor(value / 60);
    return (
      ('00' + minutes).slice(-2) +
      ':' +
      ('00' + Math.floor(value - minutes * 60)).slice(-2)
    );
  }

  constructor(
    public activeModal: NgbActiveModal,
    private userService: UserService,
    private localService: StorageService,
    private stateService: StateService,
    private toastr: ToastrService
  ) {
    this.form = this.toFormGroup(this.formInput);
  }

  public signInObj: any = {
    phone: '',
    email: '',
    otp: '',
  };

  phone: string;
  email: string;
  isSignInPage = true;
  isSignInByPhone = false;

  msgDisplayBody = 'Email Address';
  msgDisplayFooter = 'Mobile Number';
  error = '';

  changeSignUpMethod() {
    

    if (!this.isSignInByPhone) {
      this.isSignInByPhone = !this.isSignInByPhone;
      this.msgDisplayFooter = 'Email Address';
      this.msgDisplayBody = 'Mobile Number';
      this.signInObj.email = '';
      this.error = '';
      this.isSubmit = false;
    } else {
      this.isSignInByPhone = !this.isSignInByPhone;
      this.msgDisplayFooter = 'Mobile Number';
      this.msgDisplayBody = 'Email Address';
      this.signInObj.phone = '';
      this.error = '';
      this.isSubmit = false;
    }
  }

  resendOtp() {
    

    this.counter = 30;
    this.changeCounterState();
    if (this.isSignInByPhone) {
      this.userService.sendPhoneOtp({ phone: this.signInObj.phone }).subscribe({
        next: (res: any) => {
          this.toastr.info(res?.meta?.status_message);
        },
        error: (err: any) => {
          this.toastr.error('Something Went Wrong');
        },
      });
    } else {
      this.userService.sendEmailOtp({ email: this.signInObj.email }).subscribe({
        next: (res: any) => {
          this.toastr.info(res?.meta?.status_message);
        },
        error: (err: any) => {
          this.toastr.error('Something Went Wrong');
        },
      });
    }
  }

  continue() {
    

    this.phone = this.signInObj.phone;
    this.email = this.signInObj.email;

    if (this.isSignInPage) {
      if (this.isSignInByPhone) {
        this.checkPhoneRegx({ target: { value: this.signInObj.phone } });
      } else {
        this.checkEmailRegx({ target: { value: this.signInObj.email } });
      }
      if (this.error != '') {
        this.isSubmit = true;
        return;
      }
      this.isApiHit = true
      if (this.isSignInByPhone) {
        this.userService
          .sendPhoneOtp({ phone: this.signInObj.phone })
          .subscribe({
            next: (res: any) => {
              if (res?.meta?.status_code) {
                this.toastr.info(res?.meta?.status_message);
                this.counterStatus = true;
                this.isSignInPage = !this.isSignInPage;
                this.changeCounterState();
              } else {
                this.isApiHit = false
                this.toastr.error(res.meta.status_message);
              }
            },
            error: (err: any) => {
              this.toastr.error('Something Went Wrong');
            },
          });
      } else {
        this.userService
          .sendEmailOtp({ email: this.signInObj.email })
          .subscribe({
            next: (res: any) => {
              if (res?.meta?.status_code) {
                this.toastr.info(res?.meta?.status_message);
                this.counterStatus = true;
                this.isSignInPage = !this.isSignInPage;
                this.changeCounterState();
              } else {
                this.toastr.error(res.meta.status_message);
                this.isApiHit = false
              }
            },
            error: (err: any) => {
              this.toastr.error('Something Went Wrong');
            },
          });
      }

    } else {
      this.signInObj.otp =
        this.form.value.input1 +
        this.form.value.input2 +
        this.form.value.input3 +
        this.form.value.input4 +
        this.form.value.input5 +
        this.form.value.input6;
      if (this.signInObj.otp.length != 6) {
        this.error = 'Please enter OTP.';
        return;
      }
      this.userService
        .signIn({
          phone: this.signInObj.phone,
          email: this.signInObj.email,
          otp: this.signInObj.otp,
          guestCartId: Number(this.guestCartId),
        })
        .pipe(takeUntil(this.unsubscribe$))
        .subscribe((res: any) => {
          if (res.token) {
            if (this.signInObj.phone) {
              this.localService.setItem(SIGNUP_MOBILE, this.signInObj.phone);
              this.localService.removeItem(SIGNUP_EMAIL);
            } else {
              this.localService.setItem(SIGNUP_EMAIL, this.signInObj.email);
              this.localService.removeItem(SIGNUP_MOBILE);
            }
            this.activeModal.close(res);
            if (this.countDown$ != null) this.countDown$.unsubscribe();
          }
          else if (!res.userActive) {
            this.toastr.info(res?.message);
            this.activeModal.close()
          }
          else {
            this.signInObj.otp = '';
            this.form.reset();
            this.toastr.info(res?.message);
          }
        });
    }
  }

  changeCounterState(): void {
    this.countDown$ = timer(0, this.tick)
      .pipe(take(this.counter))
      .subscribe(() => {
        --this.counter;
        if (this.counter == 0) {
          this.countDown$.unsubscribe();
        }
      });
  }

  close() {
    this.activeModal.close();
  }

  change(): void {
    
    this.isApiHit = false;
    if (this.countDown$ != null) this.countDown$.unsubscribe();
    this.counter = 30

    this.error = '';
    this.form = this.toFormGroup(this.formInput);
    if (this.isSignInByPhone) {
      this.isSignInPage = true;
      this.isSignInByPhone = true;
    } else {
      this.isSignInPage = true;
      this.isSignInByPhone = false;
    }
  }

  checkPhoneRegx(event: any): void {
    const target = event.target;
    if (!NUM_REGEX.test(target.value)) {
      target.value = target.value.slice(0, -1);
    }
    if (target.value == '') {
      this.error = 'Mobile number is required';
    } else if (!PHONE_REGEX.test(target.value)) {
      this.error = 'Please enter a valid Mobile Number.';
    } else {
      this.error = '';
    }
  }

  checkEmailRegx(event: any): void {
    const target = event.target;
    if (target.value == '') {
      this.error = 'Email is required';
    } else if (!EMAIL_REGEX.test(target.value)) {
      this.error = 'Please enter a valid Email.';
    } else {
      this.error = '';
    }
  }

  ngOnDestroy() {
    this.unsubscribe$.next(true);
    this.unsubscribe$.complete();
    this.countDown$ && this.countDown$.unsubscribe();
  }
}